import { EventHandler } from '@n7-frontend/core';

export class ManageAlertsAlertEH extends EventHandler {
  public listen() {

    this.innerEvents$.subscribe(event => {
      switch(event.type){
        case 'manage-alerts-alert.click':
            this.emitOuter('click', event.payload);
            break;

        default: 
          break;
      }
    });

    this.outerEvents$.subscribe(event => {
      // TODO
    });
  }
}
